export const treatments_list = [
    { value: 'invisalign_consultation', label: 'Invisalign consultation' },
    { value: 'implant_consultation', label: 'Implant consultation' },
    { value: 'veneers_consultation', label: 'Veneers consultation' },
    { value: 'emergency', label: 'Emergency - Toothpain/Broken tooth' } ,
    { value: 'teeth_whitening_homekit', label: 'Teeth Whitening - Homekit' },
    { value: 'teeth_whitening_clinic', label: 'Teeth Whitening - In clinic' },
    { value: 'second_opinion', label: 'Second opinion' },
    { value: 'dental_checkup', label: 'Dental checkup' } ,
    { value: 'check_clean', label: 'Check and Clean' },
    { value: 'teeth_cleaning', label: 'Teeth cleaning' },
    { value: 'cosmetic_consultation', label: 'Cosmetic consultation' },
    { value: 'online_dentist', label: 'Online Dentist' } ,
  ];
